import gButton from "@/components/g-button/g-button";
import gCard from "@/components/g-card/g-card.vue";
import gDateInput from "@/components/g-date-input/g-date-input";
import gForm from "@/components/g-form/g-form";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import ProdutosClienteViewModel from "@/shared/view-models/ProdutosClienteViewModel";
import FiltroProdutoCliente from "@/shared/view-models/Filtros/FiltroProdutoCliente";
import ProdutoController from "@/shared/controllers/produto/produtoController";
import { defineComponent } from "vue";

const name = 'ProdutosCliente'

export default defineComponent({
  name,

  components: {
    'g-button': gButton,
    'g-card': gCard,
    'g-date-input': gDateInput,
    'g-form': gForm
  },

  props: { },

  mounted () {
    //this.getEmpresas()
    //this.getEnumDescription()
    //this.GetProdutosPorClienteEFiltro()
    this.UnidadeArray = EmpresaController.getEmpresasAtivas().EmpresaArray;
    this.popularDropDownEmpresa();
    this.mitt.on('trocaEmpresaRepresentante', () => {
      this.atualizaEmpresaRepresentante()
    })
    
    this.representanteId = this.$store.state.representanteSelecionadoId;

  },

  updated () { },
  watch: {
    objFiltro() {
      if (this.objFiltro.ClienteId == (undefined || null))
      {
        this.ClienteAgrupadorAtiva = true;
      }
     }
  },
  data () {
    return {
      NomeEmpresa: '',
      NomeCliente: '',
      ClienteArray: [],
      UnidadeArray: [],
      ColunaMedidas: [],
      componenteArray: [],
      componentePedidoArray: [],
      popup: false,
      ClienteAgrupadorAtiva: true,
      //ProdutosClienteArray: [],
      InfosArray: [],
      representanteId: null,
      objFiltro: new FiltroProdutoCliente(),
      ProdutosCliente: new ProdutosClienteViewModel(),
      ConsultarDadosClienteAgrupador: null,
      ComponentesExpandidos: null,
      ProdutoEncontrado: true,
      ProdutoArray: [],
      EmpresaArray: [],
      numeroLinha:0,
      OrdenacaoArray: [{ value: "codigo", text: "Código" },{ value: "descricao", text: "Descrição" },],

      Colunas : [
        {field: 'produto', header: 'Nome do Produto', ordena:true},
        {field: 'dataUltimaVendaFormatada', header: 'Data Última Venda', ordena: true, ordenacao: 'dataUltimaVenda'},
        {field: 'dataUltimoFaturamentoFormatada', header: 'Data Último Faturamento', ordena: true, ordenacao: 'dataUltimoFaturamento'},

      ],

      ColunasSubGrid: [
        { field: "componenteTipoTexto", header: "Componentes" },
        { field: "ColunaMedidas", header: "Comprimento x Largura x Altura x Altura da Tampa" },
    ],

      Filtro: {
        'global': {value: null, matchMode: this.filtros.CONTAINS},
        'codigoProduto': {value: null, matchMode:this.filtros.CONTAINS},
        'nomeProduto': {value: null, matchMode: this.filtros.CONTAINS},
        'nomeFantasia': {value: null, matchMode: this.filtros.CONTAINS},
        'nomeEmpresa': {value: null, matchMode: this.filtros.CONTAINS},
        'dataUltimaVendaFormatada': {value: null, matchMode: this.filtros.CONTAINS},
        'dataUltimoFaturamentoFormatada': {value: null, matchMode: this.filtros.CONTAINS},
      },
    }
  },

  methods: {
    ativaClienteAgrupador() {
      this.ClienteAgrupadorAtiva = false;
    },

    Grid() {
      this.GetProdutosPorClienteEFiltro()
    },

    getProduto(pesquisa) {
      let empresaSelecionadaId = this.objFiltro.UnidadeId ? this.objFiltro.UnidadeId : this.$store.state.empresaSelecionadaId

      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ProdutoController.GetProdutoByPesquisaRepresentante(pesquisa, empresaSelecionadaId, this.representanteId, this.objFiltro.ClienteId).requisicao
        .then((res) => {
          this.ProdutoArray = res.data.data
        })
        .catch(() => {
        })
      }, 1000);
    },

    GetProdutosPorClienteEFiltro() {
      let empresaSelecionadaId = this.objFiltro.UnidadeId ? this.objFiltro.UnidadeId : this.$store.state.empresaSelecionadaId
      this.$isLoading(true)
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `ProdutoCliente/GetProdutosPorClienteEFiltro/${empresaSelecionadaId}/${this.representanteId}`,
        data: (this.objFiltro)
      })
        .then((response) => {
          this.ProdutoEncontrado = false;
          this.InfosArray = response.data.data || [];
        })
        .finally(() => {
          this.$isLoading(false)
        });

    },

    FormataMedidas(componenteArray){
      componenteArray.forEach((r)=>{
        r.ColunaMedidas = `${r.numeroComprimento} x ${r.numeroLargura} x  ${r.numeroAltura} x ${r.numeroAlturaTampa}`
      })
      return componenteArray //this.ColunaMedidas = r.ColunaMedidas
    },

    atualizaEmpresaRepresentante() {
      // this.objFiltro.UnidadeId = this.$store.state.empresaSelecionadaId;
      this.representanteId = this.$store.state.representanteSelecionadoId;
    },


    buscarClientes(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ClienteArray = ClienteController.GetAllClientesByEmpresaIdEFiltro(this.objFiltro.UnidadeId,event).ClientesArray;
      }, 1000);
    },

    popularDropDownEmpresa(){
      this.EmpresaArray = this.$store.state.EmpresaArray;
      this.atualizaEmpresaRepresentante()
      },

    // getEmpresas() {
    //   EmpresaController.getAllEmpresa()
    //     .requisicao.then((Response) => {
    //       this.EmpresaArray = Response.data.data;
    //     })
    //     .catch((Error) => {
    //       console.error(Error);
    //     });
    // },


    // buscarByFiltro(){
    //   this.$isLoading(true)
    //   ProdutoClienteController.GetProdutoClienteByFiltro(this.objFiltro).requisicao
    //     .then((response) =>{
    //         this.ProdutosClienteArray = response.data.data;
    //         this.ProdutoEncontrado = true
    //     })
    //     .finally(() => this.$isLoading(false))
    // },

    redirecionaTelaDetalhes(data) {
      const rotaNovaAbaURL = this.$router.resolve({
        path: `produtos-cliente-detalhes/${data.produtoId}`
      }).href;
      
      window.open(rotaNovaAbaURL, '_blank');
    },

    limpar() {
      this.objFiltro = new FiltroProdutoCliente();
      this.ClienteArray = []
      EmpresaController.getEmpresasAtivas().requisicao
      .then(response => {
        this.UnidadeArray = response.data.data
        this.atualizaEmpresaRepresentante()
      })
      this.mitt.on('trocaEmpresaRepresentante', () => {
        this.atualizaEmpresaRepresentante()
      })
    },

   },

  computed: { },

});



